module.exports = __webpack_public_path__ + "static/media/onboardinglogo.c2623f61.svg";